import { getSoftwaresAPI } from '@optisewer/library';
import { setSnackbar } from '@shared/library';
import { AxiosError } from 'axios';
import React from 'react';
import './Site.scss';
//COMPONENTS
import Content from './Content/Content';
import Header from './Header/Header';
import Sidebar from './Sidebar/Sidebar';
//CONTEXTS
import { languages } from '../../../language';
import { CntxConfig } from '../../Optisewer';
//MODELS
import { MenuArea_model } from '../../../models/ui_data/MenuArea_model';
//STATIC
import { config } from '../../../static/config';
import { buildMenuFromOptions } from '../../../static/methods';

const Site = () => {
    //CONTEXTS USE
    const cntxConfig = React.useContext(CntxConfig)!;

    //STATIC DATA
    const lang = languages(cntxConfig.settings?.lang);

    //#region STATES
    const [isOpened, setIsOpened] = React.useState(false);
    const [menu, setMenu] = React.useState<MenuArea_model[]>([]);
    const [menuLoaded, setMenuLoaded] = React.useState(false);
    //#endregion

    //STATES CHANGE
    React.useEffect(() => {
        getSoftwaresAPI(config.api.internal, { enableOnlyAllowed: true })
            .then(res => setMenu(buildMenuFromOptions(res)))
            .catch((err: AxiosError) => {
                console.error(err);
                setSnackbar(cntxConfig, { message: lang.error_loading_menu, severity: "error" });
            })
            .finally(() => setMenuLoaded(true));
    }, []);

    return (
        <div id="Site">
            <Sidebar {...{ isOpened, setIsOpened, menu }} />

            <div id="content">
                <Header {...{ isOpened }} />
                <Content {...{ menu, menuLoaded }} />
            </div>
        </div>
    );
};
export default React.memo(Site);